// extracted by mini-css-extract-plugin
export var csatScore = "_nj-5";
export var header = "_nj-1";
export var panelWrapper = "_nj-2";
export var postPreview = "_nj-3";
export var rightContent = "_nj-0";
export var wrappingText = "_nj-4";